import axios from "axios";
import { supabase } from "./supabaseClient";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

// Always pull the freshest token before each request
api.interceptors.request.use(async (config) => {
  try {
    const { data } = await supabase.auth.getSession();
    const token = data?.session?.access_token;
    if (token) {
      config.headers = config.headers || {};
      config.headers.Authorization = `Bearer ${token}`;
    }
  } catch (_) {
    // ignore
  }
  return config;
});

export async function listIndustries() {
  const { data } = await api.get("/industries");
  return data.industries || [];
}

export async function getIndustry(slug) {
  const { data } = await api.get(`/industries/${slug}`);
  return data;
}

export async function getProblem(industrySlug, problemSlug) {
  const { data } = await api.get(`/industries/${industrySlug}/problems/${problemSlug}`);
  return data;
}

export async function searchProblems() {
  const { data } = await api.get(`/search/problems`);
  return data.items || [];
}

export async function generateFramework(industry_id, problem_id) {
  const { data } = await api.post(`/generate-framework`, { industry_id, problem_id });
  return data;
}

export async function getMe() {
  const { data } = await api.get(`/me`);
  return data;
}

export async function listBookmarks() {
  const { data } = await api.get(`/me/bookmarks`);
  return data.bookmarks || [];
}

export async function addBookmark(problem_id) {
  const { data } = await api.post(`/me/bookmarks`, { problem_id });
  return data;
}

export async function removeBookmark(problem_id) {
  const { data } = await api.delete(`/me/bookmarks/${problem_id}`);
  return data;
}

export async function adminCreateFramework(payload) {
  const { data } = await api.post(`/admin/frameworks`, payload);
  return data.framework;
}

export async function adminCreateProblem(payload) {
  const { data } = await api.post(`/admin/problems`, payload);
  return data.problem;
}
